import React, { useState, useEffect } from 'react';
import './App.css';
import { Row, Col, Spinner } from 'reactstrap';
import { Table, Header } from 'semantic-ui-react'
import Loader from './components/Loader'
import Error from './components/Error'
import { faSyringe, faCalendarAlt, faBuilding, faClinicMedical, faAmbulance, faBong, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import QRCode from 'qrcode'

const App = ({ result }) => {

    const [userData, setUserData] = useState(null);
    const [docRetrieving, setDocRetrieving] = useState(true);
    const [docDataValidating, setDocDataValidating] = useState(true);
    const [docIssuerValidating, setDocIssuerValidating] = useState(true);
    const [dataVersion, setDataVersion] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [qrToken, setQrToken] = useState(null);
    const [modalState, setModalOpen] = useState(false);
    const [certStatus, setCertStatus] = useState(null);
    const [unableRetrieveCert, setUnableRetrieveCert] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        let formattedResult = result.replace(/'/g, '"');
        formattedResult = JSON.parse(formattedResult)
        let qr_token = formattedResult.qr_token;
        setQrToken(qr_token)

        if (qr_token) {
            fetch('/get_user_data/', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(qr_token),
            })
                .then(res => res.json())
                .then(res => {

                    if ("results" in res) {
                        if (res.results === 'data not found') {
                            setError(true)
                            setUnableRetrieveCert(true)
                        }
                    }

                    setDocRetrieving(false)
                    if (res.cert_status === 0) {
                        setCertStatus(res.cert_status)
                        setError(true)
                    } else {
                        setCertStatus(res.cert_status)
                        //// util functions

                        function hexStringToArrayBuffer(hexString) {
                            // remove the leading 0x
                            hexString = hexString.replace(/^0x/, '');

                            // ensure even number of characters
                            if (hexString.length % 2 != 0) {
                                console.log('WARNING: expecting an even number of characters in the hexString');
                            }

                            // check for some non-hex characters
                            var bad = hexString.match(/[G-Z\s]/i);
                            if (bad) {
                                console.log('WARNING: found non-hex characters', bad);
                            }

                            // split the string into pairs of octets
                            var pairs = hexString.match(/[\dA-F]{2}/gi);

                            // convert the octets to integers
                            var integers = pairs.map(function (s) {
                                return parseInt(s, 16);
                            });

                            var array = new Uint8Array(integers);
                            // console.log(array);
                            return array.buffer;
                        }


                        function getMessageEncoding(data) {
                            let enc = new TextEncoder();
                            return enc.encode(data);
                        }


                        //// Verifying Signature

                        let pk_jwk_key = res.signature.public_key;

                        // signature require to be of type array buffer
                        let hexSignature = res.signature.sig_val
                        var signatureArrBuf = hexStringToArrayBuffer(hexSignature)

                        // data require to be of type array buffer
                        let encodedMessage = getMessageEncoding(res.user_data);

                        window.crypto.subtle.importKey("jwk", pk_jwk_key, {
                            name: "RSA-PSS",
                            hash: "SHA-256",
                        }, false, ["verify"])
                            .then(function (pk) {
                                window.crypto.subtle.verify({ name: "RSA-PSS", saltLength: 32 }, pk, signatureArrBuf, encodedMessage)
                                    .then(function (isvalid) {
                                        //returns a boolean on whether the signature is true or not
                                        if (isvalid) {
                                            setTimeout(
                                                () => setDocDataValidating(false),
                                                750
                                            );

                                            setTimeout(
                                                () => setDocIssuerValidating(false),
                                                1000
                                            );
                                            setTimeout(
                                                () => { setUserData(JSON.parse(res.user_data)); setDataVersion(res.version); setLoading(false); },
                                                2410
                                            );

                                        } else {
                                            setTimeout(
                                                () => { setError(true); setLoading(false); },
                                                800
                                            );
                                        }
                                    }).catch(function (err) {
                                        console.error(err);
                                        setError(true)
                                        setLoading(false);
                                    });
                            }).catch(function (err) {
                                console.error(err);
                                setError(true)
                                setLoading(false);
                            });
                    }



                })
                .catch(err => {
                    console.log(err)
                    setError(true)
                    setLoading(false);
                });
        }
    }, []);

    function copy() {
        const el = document.createElement("input");
        el.value = window.location.href;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        setCopied(true);
    }


    if (error) {
        return (<Error isCertCanceled={certStatus} isUnableRetrieveCert={unableRetrieveCert} />)
    }

    if (docRetrieving || docDataValidating || docIssuerValidating || loading) {
        return (<Loader docReceived={!docRetrieving} docDataValidated={!docDataValidating} docIssuerValidated={!docIssuerValidating} />)
    }



    if (userData) {
        let vaccine_record = []
        if (userData.vaccines.length != 0) {
            vaccine_record = userData.vaccines.sort((a, b) => Date.parse(new Date(a.vacc_date.split("-").reverse().join("-"))) - Date.parse(new Date(b.vacc_date.split("-").reverse().join("-"))));
        }

        let canvas;
        // For QR Code
        canvas = document.createElement('canvas');
        QRCode.toCanvas(canvas, 'https://cert-intervac.ddc.moph.go.th/' + qrToken, { errorCorrectionLevel: 'H' });
        const qr = canvas.toDataURL();


        const CertDoc_en = () => (
            <Document>
                <Page style={styles.body} wrap>
                    <View style={{ width: "100%", justifyContent: 'center', display: 'flex', alignItems: "center" }}>
                        <Image
                            style={{ height: 80 }}
                            src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/logoDDC.jpg"
                        />
                    </View>
                    <Text style={styles.title}>International COVID-19 Vaccination Certificate</Text>
                    <Text style={{ ...styles.title, marginTop: 2, fontSize: 5 }}>{' '}</Text>

                    <View style={{ display: 'flex', justifyContent: 'center', marginTop: 1, marginBottom: 10, alignItems: 'center' }}><View style={{
                        width: '79%',
                        borderBottomColor: 'gray',
                        borderBottomWidth: 1,
                    }}></View></View>

                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <View style={{ flex: 3 }}>
                            <View style={{ display: 'flex', flexDirection: 'row' }}>
                                <View style={{ flex: 3 }}>
                                    <Text style={styles.username}>
                                        Name
                                    </Text>
                                    <Text style={{ ...styles.username, fontSize: 1.2, marginTop: 0 }}>{' '}</Text>
                                </View>
                                <View style={{ flex: 5 }}>
                                    <Text style={{ ...styles.username, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{userData.pre_name}{' '}{userData.f_name}{' '}{userData.l_name}</Text>
                                </View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'row' }}>
                                <View style={{ flex: 3 }}>
                                    <Text style={styles.data}>
                                        Passport No.
                                    </Text>
                                    <Text style={{ ...styles.data, fontSize: 1.2, marginTop: 0 }}>{' '}</Text>

                                </View>
                                <View style={{ flex: 5 }}>
                                    <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{userData.passport_no}</Text>
                                </View>
                            </View>

                            <View style={{ display: 'flex', flexDirection: 'row' }}>
                                <View style={{ flex: 3 }}>
                                    <Text style={styles.data}>
                                        Nationality
                                    </Text>
                                    <Text style={{ ...styles.data, fontSize: 1.2, marginTop: 0 }}>{' '}</Text>
                                </View>
                                <View style={{ flex: 5 }}>
                                    <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{userData.is_thai ? 'THAI' : userData.nation.toUpperCase()}</Text>
                                </View>
                            </View>

                            <View style={{ display: 'flex', flexDirection: 'row' }}>
                                <View style={{ flex: 3 }}>
                                    <Text style={styles.data}>
                                        Date of Birth
                                    </Text>
                                    <Text style={{ ...styles.data, fontSize: 1.2, marginTop: 0 }}>{' '}</Text>
                                </View>
                                <View style={{ flex: 5 }}>
                                    <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{userData.has_bd_day ? userData.birth_date.split("-")[0] : 'XX'}{'-'}{userData.has_bd_month ? userData.birth_date.split("-")[1] : 'XX'}{'-'}{userData.birth_date.split("-")[2]}</Text>
                                </View>
                            </View>

                            <View style={{ display: 'flex', flexDirection: 'row' }}>
                                <View style={{ flex: 3 }}>
                                    <Text style={styles.data}>
                                        Sex
                                    </Text>
                                    <Text style={{ ...styles.data, fontSize: 1.2, marginTop: 0 }}>{' '}</Text>

                                </View>
                                <View style={{ flex: 5 }}>
                                    {(userData.sex === 'm' || userData.sex === 'M') && (
                                        <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{'Male'}</Text>)}
                                    {(userData.sex === 'f' || userData.sex === 'F') && (
                                        <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{'Female'}</Text>)}
                                    {(userData.sex !== 'm' && userData.sex !== 'M' && userData.sex !== 'f' && userData.sex !== 'F') && (
                                        <Text style={{ ...styles.data, fontSize: 11.3, fontFamily: 'OpenSans-SemiBold' }}>{userData.sex}</Text>)}
                                </View>
                            </View>
                        </View>

                        <View style={{ flex: 2, justifyContent: 'center', display: 'flex', alignItems: "center", alignContent: 'center' }}>
                            <Image src={qr} style={{ width: 150 }} />
                        </View>
                    </View>



                    <View style={{ display: 'flex', justifyContent: 'center', marginTop: 9, alignItems: 'center' }}><View style={{
                        width: '95%',
                        borderBottomColor: 'gray',
                        borderBottomWidth: 0.5,
                    }}></View></View>

                    <View style={{ marginTop: 10 }}>
                        <View style={styles.titleRibbon}>
                            <Text style={styles.titleText}>Certificate Information
                            </Text>
                        </View>

                        <View style={{ display: 'flex', flexDirection: 'row' }}>
                            <View style={{ flex: 1 }}>
                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ display: 'flex', flexDirection: 'row', flex: 3 }}>
                                        <View style={{ flex: 5 }}>
                                            <Text style={styles.data}>
                                                Certificate Status
                                            </Text>
                                        </View>
                                        <View style={{ flex: 6 }}>
                                            <Text style={{ ...styles.data, fontFamily: 'OpenSans-SemiBold', fontSize: 11, color: certStatus == 1 ? 'green' : 'gray' }}>{certStatus === 1 ? 'VALID' : 'INVALID'}</Text>
                                        </View>
                                    </View>
                                    <View style={{ flex: 2 }}>
                                        <View style={{ display: 'flex', flexDirection: 'row' }}>
                                            <View style={{ flex: 5 }}>
                                                <Text style={styles.data}>
                                                    Issuance Date
                                                </Text>
                                            </View>
                                            <View style={{ flex: 6 }}>
                                                <Text style={{ ...styles.data, fontSize: 11, fontFamily: 'OpenSans-SemiBold' }}>{dataVersion == '1.4' ? vaccine_record[vaccine_record.length - 1]["issue_date"] : userData.issue_date}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ flex: 3 }}>
                                        <Text style={styles.data}>
                                            Certificate Identifier
                                        </Text>
                                    </View>
                                    <View style={{ flex: 8 }}>
                                        <Text style={{ ...styles.data, fontSize: 11, fontFamily: 'OpenSans-SemiBold' }}>{userData.cert_id}</Text>
                                    </View>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ flex: 3 }}>
                                        <Text style={styles.data}>
                                            Certificate Issuer
                                        </Text>
                                    </View>
                                    <View style={{ flex: 8 }}>
                                        <Text style={{ ...styles.data, fontSize: 11, fontFamily: 'OpenSans-SemiBold' }}>{dataVersion == '1.4' ? vaccine_record[vaccine_record.length - 1]["cert_issuer"] : userData.cert_issuer}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>

                    </View>
                    <View style={{ display: 'flex', justifyContent: 'center', marginTop: 15, marginBottom: 3, alignItems: 'center' }}><View style={{
                        width: '95%',
                        borderBottomColor: 'gray',
                        borderBottomWidth: 0.5,
                    }}></View></View>

                    <View style={{ marginTop: 8 }}>
                        <View style={{ ...styles.titleRibbon, width: 280 }}>
                            <Text style={styles.titleText}>Vaccination Record
                            </Text>
                        </View>
                    </View>
                    <View>

                        {(vaccine_record.length == 0) && (<Text style={{ marginLeft: 17, marginTop: 15, fontFamily: "OpenSans-SemiBold", color: "red", fontSize: 11.5 }}>Record not found</Text>)}

                        <View style={{ ...styles.table, marginLeft: 10, marginTop: 8 }}>
                            {(vaccine_record.length > 0) && (
                                <View style={styles.tableRowH}>
                                    <View style={{ ...styles.tableColH, width: "7%" }}>
                                        <Text style={styles.tableCellH}>Dose</Text>
                                    </View>
                                    <View style={styles.tableColH}>
                                        <Text style={styles.tableCellH}>Name of Vaccine</Text>
                                    </View>
                                    <View style={styles.tableColH}>
                                        <Text style={styles.tableCellH}>Date of Vaccination</Text>
                                    </View>
                                    <View style={{ ...styles.tableColH, width: "17%" }}>
                                        <Text style={styles.tableCellH}>Vaccine Batch Number</Text>
                                    </View>
                                    <View style={{ ...styles.tableColH, width: '23%' }}>
                                        <Text style={styles.tableCellH}>Vaccine Manufacturer</Text>
                                    </View>
                                    <View style={{ ...styles.tableColH, width: '15%' }}>
                                        <Text style={styles.tableCellH}>Administering Center</Text>
                                    </View>
                                </View>)}

                            {(vaccine_record.length > 0) && (vaccine_record.map((item, i) => {
                                return (
                                    <View style={styles.tableRow} wrap={false}>
                                        <View style={styles.tableColDose}>
                                            <Text style={styles.tableCell}>{i + 1}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{item.vacc_name}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{item.vacc_date}</Text>
                                        </View>
                                        <View style={styles.tableColLot}>
                                            <Text style={styles.tableCell}>{item.vacc_lotno}</Text>
                                        </View>
                                        <View style={{ ...styles.tableCol, width: '23%' }}>
                                            <Text style={styles.tableCell}>{item.vacc_manufac}</Text>
                                        </View>
                                        <View style={{ ...styles.tableCol, width: '15%' }}>
                                            <Text style={styles.tableCell}>{item.adm_center}</Text>
                                        </View>
                                    </View>
                                )
                            }))}

                        </View>
                    </View>
                    <Text style={{ ...styles.infoText2, fontSize: 9 }}>Date Format: DD-MM-YYYY</Text>

                    {/* <View style={{ display: 'flex', justifyContent: 'center', marginTop: 10, alignItems: 'center' }}>
                  <View style={{
                  width: '95%',
                  borderBottomColor: 'gray',
                  borderBottomWidth: 0.5,
                }}></View></View> */}
                    {/* <Text style={{ ...styles.pageNumber, paddingLeft: 40, paddingRight: 40 }} render={({ pageNumber, totalPages }) => (
                        `The electronic certificate is provided by Department of Disease Control Ministry of Public Health, Thailand.\n Authenticity of the data above is protected by an RSA digital signature.`

                    )} fixed /> */}
                    {/* <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                  `DDC-MOPH THAILAND`
                )} fixed /> */}
                    {/* <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                  `${pageNumber} / ${totalPages}`
                )} fixed /> */}
                </Page>
            </Document>
        );


        Font.register({
            family: "OpenSans",
            src: "https://fonts.gstatic.com/s/opensans/v26/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4uaVc.ttf"
        });

        Font.register({
            family: "OpenSans-SemiBold",
            src: "https://fonts.gstatic.com/s/opensans/v26/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1x4uaVc.ttf"
        });


        Font.register({
            family: "OpenSans-Bold",
            src: "https://fonts.gstatic.com/s/opensans/v26/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1x4uaVc.ttf"
        });

        const styles = StyleSheet.create({
            nameText: { fontFamily: "OpenSans", flexDirection: "row", width: '100%', flex: 1, paddingLeft: 10, marginTop: 25, fontSize: 14 },
            infoText2: { lineHeight: 1, fontFamily: "OpenSans", flexDirection: "row", width: '100%', flex: 1, paddingLeft: 10, marginTop: 8, fontSize: 14 },
            infoTitle: { fontFamily: "OpenSans-SemiBold", fontSize: 9.5, paddingBottom: 0, marginBottom: 0 },
            infoDetail: { fontFamily: "OpenSans", fontSize: 9.5, paddingBottom: 0, marginBottom: 0 },
            titleRibbon: { backgroundColor: "#3e8a66", height: 26, width: '60%', maxWidth: 190, justifyContent: 'center', paddingLeft: 6, paddingRight: 10, borderTopRightRadius: 10, borderBottomRightRadius: 10, borderTopLeftRadius: 2, borderBottomLeftRadius: 2, marginLeft: 10, marginBottom: 5 },
            titleText: { fontFamily: "OpenSans-SemiBold", color: 'white', fontSize: 11 },

            table: { display: "table", width: "auto", borderRadius: 5, borderStyle: "solid", borderWidth: 1, borderColor: 'gray' },
            tableRow: { margin: "auto", flexDirection: "row", backgroundColor: 'white' },
            tableCol: { width: "19%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0 },
            tableCell: { margin: "auto", marginTop: 6.5, marginBottom: 6.5, fontSize: 9.2, fontFamily: "OpenSans" },

            tableRowH: { margin: "auto", flexDirection: "row", backgroundColor: '#A7C9B9', borderTopLeftRadius: 4, borderTopRightRadius: 4 },
            tableColH: { width: "19%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0, display: "flex", justifyContent: 'center', paddingTop: 1, paddingBottom: 1 },
            tableCellH: { textAlign: 'center', marginTop: 2, marginBottom: 2, fontSize: 9.2, fontFamily: "OpenSans-SemiBold" },

            tableColDose: { width: "7%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0 },

            tableColLot: { width: "17%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0 },

            tableColDoseH: { textAlign: 'center', paddingTop: 1, width: "7%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0 },

            tableColLotH: { textAlign: 'center', paddingTop: 1, width: "17%", borderStyle: "solid", borderWidth: 0.5, borderLeftWidth: 0, borderTopWidth: 0 },


            body: {
                paddingTop: 35,
                paddingBottom: 65,
                paddingHorizontal: 35,
            },
            title: {
                fontSize: 14.5,
                textAlign: 'center',
                fontFamily: 'OpenSans-Bold',
                marginTop: 17,
                fontWeight: 'bold',
            },
            author: {
                fontSize: 12.2,
                textAlign: 'center',
                marginBottom: 40,
            },
            username: {
                fontSize: 10.7,
                marginLeft: 17,
                marginTop: 18.5,
                fontFamily: 'OpenSans',
                fontWeight: 'bold'
            },
            data: {
                fontSize: 10.7,
                marginLeft: 17,
                marginTop: 8,
                fontFamily: 'OpenSans',
                fontWeight: 'bold'
            },
            subtitle: {
                fontSize: 14,
                margin: 12,
                marginTop: 55,
                fontFamily: 'OpenSans-SemiBold',
                fontWeight: 600
            },
            text: {
                margin: 12,
                fontSize: 14,
                textAlign: 'justify',
                fontFamily: 'Times-Roman'
            },
            image: {
                maxWidth: 67
            },
            header: {
                fontSize: 12,
                marginBottom: 20,
                textAlign: 'center',
                color: 'grey',
            },
            pageNumber: {
                position: 'absolute',
                fontSize: 9.5,
                bottom: 30,
                left: 0,
                right: 0,
                textAlign: 'center',
                color: 'grey',
                fontFamily: 'OpenSans'
            },
        });

        return (
            <div className="App">
                <header className="App-header mt-4 mb-1">
                    <img src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/ministry-of-public-health-logo-full.png" className="App-logo mb-1" alt="logo" />
                </header>
                <div>

                    <div className='title-div' style={{ marginTop: '2%' }}>
                        <h3 className="title">International COVID-19 Vaccination Certificate</h3>
                    </div>

                    <div className="d-block d-md-none" style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                        <div style={{ margin: 0, padding: 0, borderRadius: 10, borderWidth: 'thin', marginTop: 'min(5%,15px)' }}>
                            <img src={qr} style={{ width: '75%', maxWidth: '220px', minWidth: '200px' }} />
                            <h6 className="mt-2"><b>{userData.pre_name}{' '}{userData.f_name}{' '}{userData.l_name}</b></h6>
                        </div>
                    </div>

                    <div className="d-none d-md-block" style={{ position: 'absolute', top: 10, right: '7vw' }}>
                        <div style={{ margin: 0, padding: 0, borderRadius: 10, borderWidth: 'thin', marginTop: 'min(5%,15px)' }}>
                            <img src={qr} style={{ width: '16vw', maxWidth: '170px', minWidth: '152px' }} />
                        </div>
                    </div>


                    <div className='container-header' style={{ width: '100%' }}>
                        <div style={{ width: '100%' }}>
                            <div className="d-none d-md-block">
                                <Row className='row-styling mb-1' style={{ marginLeft: "max(5px,0.1%)" }}>
                                    <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                    <Col xs='3' sm='3' md='2' lg='2' xl='2'><h5 className='info-title'>Name :  </h5></Col>
                                    <Col xs='8' sm='8' md='9' lg='9' xl='9'><h6><b>{userData.pre_name}{' '}{userData.f_name}{' '}{userData.l_name}</b></h6></Col>
                                </Row>
                            </div>
                            <Row xs='1' sm='1' md='2' lg='2' xl='2'>
                                <Col style={{ paddingLeft: 'max(5%,10px)' }}>
                                    {/* if device size > md : this will be left panel */}
                                    <Row className='row-styling mt-2 mb-3'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='5' md='7' lg='5' xl='5' className='shadow strip-bar'><h5 className='info-title-strip'>User Info</h5></Col>
                                    </Row>

                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Nationality</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{userData.is_thai ? 'THAI' : userData.nation.toUpperCase()}</p></Col>
                                    </Row>

                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Passport Number</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{userData.passport_no}</p></Col>
                                    </Row>

                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Date of Birth</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{userData.has_bd_day ? userData.birth_date.split("-")[0] : 'XX'}{'-'}{userData.has_bd_month ? userData.birth_date.split("-")[1] : 'XX'}{'-'}{userData.birth_date.split("-")[2]}</p></Col>
                                    </Row>
                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Sex</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'>

                                            {(userData.sex === 'm' || userData.sex === 'M') && (
                                                <p>{'Male'}</p>
                                            )}
                                            {(userData.sex === 'f' || userData.sex === 'F') && (
                                                <p>{'Female'}</p>
                                            )}
                                            {(userData.sex !== 'm' && userData.sex !== 'M' && userData.sex !== 'f' && userData.sex !== 'F') && (
                                                <p>{(userData.sex).toUpperCase()}</p>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col style={{ paddingLeft: 'max(5%,10px)' }}>
                                    <Row className='row-styling mt-2 mb-3'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='5' md='7' lg='5' xl='5' className='shadow strip-bar'><h5 className='info-title-strip'>Certificate Info</h5></Col>
                                    </Row>
                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Certificate Status</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p style={{ color: certStatus === 1 ? 'green' : 'gray' }}><b>{certStatus === 1 ? 'VALID' : 'INVALID'}</b></p></Col>
                                    </Row>
                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Certificate Identifier</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{userData.cert_id}</p></Col>
                                    </Row>
                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Issuance Date</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{dataVersion == '1.4' ? vaccine_record[vaccine_record.length - 1]["issue_date"] : userData.issue_date}</p></Col>
                                    </Row>
                                    <Row className='row-styling mt-1 mb-2'>
                                        <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                        <Col xs='5' sm='4' md='5' lg='5' xl='4'><h6 className='info-title'>Certificate Issuer</h6></Col>
                                        <Col xs='6' sm='7' md='6' lg='6' xl='7'><p>{dataVersion == '1.4' ? vaccine_record[vaccine_record.length - 1]["cert_issuer"] : userData.cert_issuer}</p></Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row className='row-styling mt-5'>
                                <Col xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                <Col xs='11' sm='11' md='11' lg='11' xl='11'><h5 className='info-title'>Vaccination Record</h5></Col>
                            </Row>
                            <Row className='row-styling mt-3 mb-3'>
                                <Col style={{ padding: '0', margin: '0' }} xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                {/* Below will display if device size <= xs */}
                                <Col className="d-block d-md-none" style={{ paddingRight: "5%" }} xs='11' sm='11' md='11' lg='11' xl='11'>
                                    {(vaccine_record.length == 0) && (<Row><p style={{ color: 'red' }}><i>Record not found</i></p></Row>)}
                                    {(vaccine_record.length > 0) && (vaccine_record.map((item, i) => {
                                        return (
                                            <Row className='shadow mb-4 ' style={{ borderRadius: '6px' }}>
                                                <Col className='pt-3 pb-3 col-dose' xs='2' sm='2'>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <h5>Dose</h5>
                                                        <span style={{ fontSize: 11 }}>Number</span>
                                                        <h2 className="mt-2">{i + 1}</h2>
                                                    </div>
                                                </Col>
                                                <Col className='pt-4 pb-3 col-vc-detail' xs='10' sm='10'>
                                                    <Row className='row-vc-detail mb-sm-3'>
                                                        <Col xs='2' sm='5'>
                                                            <div className="d-block d-sm-none icon-align">
                                                                <Icon icon={faSyringe} />
                                                            </div>
                                                            <div className="d-none d-sm-block"><p className='detail-title'>Vaccine Name</p></div>
                                                        </Col>
                                                        <Col xs='10' sm='7'>
                                                            <h5 className='detail-txt-focus'>{item.vacc_name}</h5>
                                                        </Col>
                                                    </Row>
                                                    <Row className='row-vc-detail mb-sm-3'>
                                                        <Col xs='2' sm='5'>
                                                            <div className="d-block d-sm-none icon-align">
                                                                <Icon icon={faCalendarAlt} />
                                                            </div>
                                                            <div className="d-none d-sm-block"><p className='detail-title'>Vaccination Date</p></div>
                                                        </Col>
                                                        <Col xs='10' sm='7'>
                                                            <p className='detail-txt-focus'>{item.vacc_date}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className='row-vc-detail mb-sm-3'>
                                                        <Col xs='2' sm='5'>
                                                            {/* <div className="d-block d-sm-none icon-align">
                                <p className='detail-title' style={{color:'rgba(5, 104, 57 ,1)', fontSize:'14.5px'}}>Lot no.</p>
                                </div>
                              <div className="d-none d-sm-block"><p className='detail-title'>Lot No.</p></div> */}
                                                            <div className="d-block d-sm-none icon-align">
                                                                <img src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/lot.svg" style={{ width: "40%", height: "auto", minWidth: "22px" }} alt="lotLogo" />
                                                            </div>
                                                            <div className="d-none d-sm-block"><p className='detail-title'>Vaccine Batch Number</p></div>
                                                        </Col>
                                                        <Col xs='10' sm='7'>
                                                            <p>{item.vacc_lotno}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className='row-vc-detail mb-sm-3'>
                                                        <Col xs='2' sm='5'>
                                                            <div className="d-block d-sm-none icon-align">
                                                                <Icon icon={faBong} />
                                                            </div>
                                                            <div className="d-none d-sm-block"><p className='detail-title'>Vaccine Manufacturer</p></div>
                                                        </Col>
                                                        <Col xs='10' sm='7'>
                                                            <p>{item.vacc_manufac}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className='row-vc-detail'>
                                                        <Col xs='2' sm='5'>
                                                            <div className="d-block d-sm-none icon-align">
                                                                <Icon icon={faClinicMedical} />
                                                            </div>
                                                            <div className="d-none d-sm-block"><p className='detail-title'>Administering Center</p></div>
                                                        </Col>
                                                        <Col xs='10' sm='7'>
                                                            <p>{item.adm_center}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        )
                                    }))}
                                </Col>
                                {/* Below will display if device size > xs */}
                                <Col className="d-none d-md-block" style={{ paddingRight: "2%" }} xs='11' sm='11' md='11' lg='11' xl='11'>
                                    <Table size='large' className='shadow'>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Dose Number</p></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Name of Vaccine</p></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Date of Vaccination</p></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Vaccine Batch Number</p></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Vaccine Manufacturer</p></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center' style={{ verticalAlign: 'text-top' }}><p className='table-title'>Administering Center</p></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            {(vaccine_record.length == 0) && (<Table.Row><Table.Cell colSpan='6' textAlign='center'><p><i>Record not found</i></p></Table.Cell></Table.Row>)}
                                            {(vaccine_record.length > 0) && (vaccine_record.map((item, i) => {
                                                return (
                                                    <Table.Row>
                                                        <Table.Cell style={{ backgroundColor: '#c8d7c6' }}>
                                                            <Header className='table-dose-title' as='h5' textAlign='center'>
                                                                {i + 1}
                                                            </Header>
                                                        </Table.Cell>
                                                        <Table.Cell singleLine><p style={{ fontWeight: "550" }}>{item.vacc_name}</p></Table.Cell>
                                                        <Table.Cell textAlign='center'><p>{item.vacc_date}</p></Table.Cell>
                                                        <Table.Cell textAlign='center'><p>{item.vacc_lotno}</p></Table.Cell>
                                                        <Table.Cell textAlign='center'><p>{item.vacc_manufac}</p></Table.Cell>
                                                        <Table.Cell textAlign='center'><p>{item.adm_center}</p></Table.Cell>
                                                    </Table.Row>)
                                            }))}
                                        </Table.Body>
                                    </Table>
                                </Col>

                                <Col className="d-none d-md-block" xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                <Col className="d-none d-md-block" xs='11' sm='11' md='11' lg='11' xl='11'><p className='mt-4' style={{ color: 'black' }}>* Date Format: DD-MM-YYYY</p></Col>

                                <Col className="d-block d-md-none" xs='1' sm='1' md='1' lg='1' xl='1'></Col>
                                <Col className="d-block d-md-none" xs='11' sm='11' md='11' lg='11' xl='11'><p className='mt-0 mb-2' style={{ color: 'gray' }}>* Date Format: DD-MM-YYYY</p></Col>
                            </Row>

                            {(vaccine_record.length > 0) && (
                                <div className="d-block d-sm-none" style={{ margin: "0 5% 5% 8%" }}>
                                    <h5 className='mb-2 mt-0' style={{ textAlign: "left" }}>Icon Representation</h5>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}>
                                            <Icon icon={faSyringe} />
                                        </div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            Name of Vaccine
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}>
                                            <Icon icon={faCalendarAlt} />
                                        </div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            Date of Vaccination
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}>
                                            <img src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/lot.svg" style={{ width: "40%", height: "auto", minWidth: "22px" }} alt="lotLogo" />
                                        </div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            Vaccine Batch Number
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}>
                                            <Icon icon={faBong} />
                                        </div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            Vaccine Manufacturer
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}>
                                            <Icon icon={faClinicMedical} />
                                        </div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            Administering Center
                                        </div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                        <Row style={{ justifyContent: "center" }}>
                            <PDFDownloadLink className='shadow'
                                style={{
                                    textDecoration: "none",
                                    padding: "18px",
                                    backgroundColor: "#e7e7e7",
                                    borderRadius: 5,
                                    fontFamily: 'Segoe UI',
                                    fontWeight: 600,
                                    color: '#00318e',
                                    width: 'auto'
                                }}
                                document={<CertDoc_en />} fileName="Vaccination Certificate.pdf">
                                {({ blob, url, loading, error }) =>
                                    loading ? (<Spinner size="sm" color="#00318e" />) : (<p style={{ fontSize: 12 }}> Download Certificate PDF <Icon icon={faDownload} /> </p>)
                                }
                            </PDFDownloadLink>
                            <span className='mt-4' style={{ fontSize: "0.9em" }}>Encounter a downloading problem?</span>
                            <div className="App" style={{ fontSize: "0.9em" }}>
                                <a target="_self" onClick={copy}>{!copied ? (<span style={{ color: '#00318e' }}><b> Click here to copy the URL link of your certificate</b></span>) : (<span style={{ color: '#00318e' }}><b>Link is Copied</b></span>)}</a>
                                <br />{' '}and paste it into the address bar of an external web browser.
                            </div>
                        </Row>


                    <footer className='mb-2 mt-5' style={{ paddingLeft: '6%', paddingRight: "6%" }}>
                        <hr />
                        <span style={{ color: "gray", fontSize: 'min(3.2vw,15px)' }}>The electronic certificate is provided by Department of Disease Control Ministry of Public Health, Thailand.</span><br />
                        <span style={{ color: "gray", fontSize: 'min(3.2vw,15px)' }}>Certificate authenticity is protected by an RSA digital signature</span>
                        <p style={{ color: "gray", marginTop: 10 }}>DDC , MOPH THAILAND</p>
                    </footer>

                </div>
            </div >
        );
    }

}

export default App;